// Dinamik rapor uc noktalari (backend servisi, port 3006).
//
// Auth servisinde DEGIL: raporlama kimlik dogrulama isi degil. Backend
// zaten cron ve is mantigi tasiyor, dogal yeri orasi.
//
// Akis: taslak -> kullanici onayi -> calistir / kaydet.
// Kaydedilmis raporlar modele ugramadan calisir.

import authService from './authService';

// Backend servisi (3006). REACT_APP_BACKEND_API_URL auth servisidir (3000),
// karistirmamak icin ayri anahtar.
const baseUrl = () => process.env.REACT_APP_BACKEND_URL;

const call = async (path, { method = 'GET', body } = {}) => {
  const url = baseUrl();
  if (!url) throw new Error('Rapor servisi adresi tanımlı değil.');

  const res = await fetch(`${url}/reports${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authService.getAccessToken()}`,
      'x-api-key': process.env.REACT_APP_API_KEY || '',
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    // NestJS hata govdesi { message } ya da { message: [] } olabiliyor.
    const msg = Array.isArray(data?.message) ? data.message.join(', ') : data?.message;
    throw new Error(msg || `İstek başarısız (${res.status})`);
  }
  return data;
};

const reportService = {
  getCatalog: () => call('/catalog'),
  /** Dogal dil -> yapilandirilmis sorgu taslagi. Calistirmaz. */
  draft: (prompt) => call('/draft', { method: 'POST', body: { prompt } }),
  run: (query) => call('/run', { method: 'POST', body: { query } }),
  list: () => call(''),
  save: (payload) => call('', { method: 'POST', body: payload }),
  runSaved: (id) => call(`/${id}/run`, { method: 'POST' }),
  update: (id, payload) => call(`/${id}`, { method: 'PUT', body: payload }),
  remove: (id) => call(`/${id}`, { method: 'DELETE' }),
};

export default reportService;
